module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "logo-white@3x.c5b9c5f8.png";